import { get } from 'lib/sequence/component/state/value'

/**
 * Returns the minimum date value according to the selected option.
 *
 * @param {string} value        the selected option's value
 * @returns {{minDate: string}} an object containing the minimum date
 */
const toDateString = (value) => {
  const date = new Date()

  switch (value) {
    // case '5m':
    //   date.setMinutes(date.getMinutes() - 5)
    //   break
    case '1h':
      date.setHours(date.getHours() - 1)
      break
    case '24h':
      date.setDate(date.getDate() - 1) // today ???
      break
    case '48h':
      date.setDate(date.getDate() - 2) // yesterday
      break
    case '7d':
      date.setDate(date.getDate() - 7)
      break
    default:
    // current timestamp
  }
  return { minDate: date.toISOString() }
}

/**
 * Sets the date created filter according to the selected value.
 *
 * @param {Gaia.AppModule.Spec} module the ticket module composition object
 * @returns {function(*, {filter?: {}}=, ...[*]): Promise<[undefined,{filter: {}},...*[]]>}
 */
export default module => async (children, { filter = {} } = {}, ...args) => {
  const { dateCreated } = children

  const accumulatedFilter = filter
  const created = get(dateCreated)

  created
    && (created !== '0' && created[0]?.key !== '0')
    && (accumulatedFilter.submit_timestamp = toDateString(created))

  return [children, { filter: accumulatedFilter }, ...args]
}
